import { computed, Directive, input, output } from '@angular/core';
import { ITicketResidentOverview, ITicketResidentOverviewHQ, TicketStatus } from '../../../models';

@Directive()
export abstract class TicketCardBaseComponent {
  readonly ticket = input<ITicketResidentOverview | ITicketResidentOverviewHQ>();
  readonly showArchiveButton = input(true);
  // Unread-message dot is an overview-only hint; hide it where the card is reused
  // elsewhere (e.g. the dashboard tickets widget). ART-19298.
  readonly showUnreadDot = input(true);
  readonly archiveTicket = output<ITicketResidentOverview | ITicketResidentOverviewHQ>();
  readonly displayDate = computed(() => {
    const ticket = this.ticket();
    const created = ticket.created;
    const date = typeof created === 'string' ? created : created?.date;

    return new Date(date).getTime();
  });

  readonly canArchive = computed(() => {
    if (!this.showArchiveButton()) return false;

    const ticket = this.ticket() as ITicketResidentOverview;

    return (
      !ticket?.archived &&
      (ticket.state === TicketStatus.CLOSED || ticket.state === TicketStatus.CANCELLED)
    );
  });

  public onArchive() {
    this.archiveTicket.emit(this.ticket());
  }
}
